import { MatterStatementOfAccount } from '@models/statementOfAccount';
import { Selector } from '@ngxs/store';
import { MatterStatementofAccountSelectors } from '@state/matter/statementOfAccounts/statementOfAccounts.selectors';

export interface DocketSyncComponentFees {
	hstTitle: MatterStatementOfAccount;
	hstWrit: MatterStatementOfAccount;
	nonHstTitle: MatterStatementOfAccount;
	nonHstWrit: MatterStatementOfAccount;
}

export class DocketSyncComponentSelector {
	@Selector([
		MatterStatementofAccountSelectors.getHST_Title,
		MatterStatementofAccountSelectors.getHST_Writ,
		MatterStatementofAccountSelectors.getNonHST_Title,
		MatterStatementofAccountSelectors.getNonHST_Writ,
	])
	public static getDocketSyncComponentFees(
		hstTitle: MatterStatementOfAccount,
		hstWrit: MatterStatementOfAccount,
		nonHstTitle: MatterStatementOfAccount,
		nonHstWrit: MatterStatementOfAccount,
	): DocketSyncComponentFees {
		return {
			hstTitle,
			hstWrit,
			nonHstTitle,
			nonHstWrit,
		};
	}
}
